var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/types.ts
import { Int } from "@adornis/baseql/baseqlTypes";
import { Entity, Field } from "@adornis/baseql/decorators";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity";
import { getCollection } from "@adornis/baseql/server/collections";
import { nonOptional } from "@adornis/validation/functions/nonOptional";
import { validate } from "@adornis/validation/decorators";
import { AdornisRoles } from "./a-roles";
var NativePermissions = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
};
NativePermissions._class = "NativePermissions";
__decorateClass([
  Field((type) => Int, { default: (v) => v ?? 0 })
], NativePermissions.prototype, "impersonationLevel", 2);
__decorateClass([
  Field((type) => Int, { default: (v) => v ?? 0 })
], NativePermissions.prototype, "passwordChangeLevel", 2);
NativePermissions = __decorateClass([
  Entity()
], NativePermissions);
var AdornisRoleToContextsWrapper = class extends AdornisEntity {
};
AdornisRoleToContextsWrapper._class = "AdornisRoleToContextsWrapper";
__decorateClass([
  Field((type) => String)
], AdornisRoleToContextsWrapper.prototype, "name", 2);
__decorateClass([
  Field((type) => [String])
], AdornisRoleToContextsWrapper.prototype, "contexts", 2);
__decorateClass([
  Field((type) => [String], {
    resolve: function() {
      return async () => {
        const role = await (await getCollection(AdornisRoles._collectionName)).findOne({ name: this.name });
        if (!role)
          return [];
        return role.permissions.map((p) => p.name);
      };
    }
  })
], AdornisRoleToContextsWrapper.prototype, "permissions", 2);
AdornisRoleToContextsWrapper = __decorateClass([
  Entity()
], AdornisRoleToContextsWrapper);
var AdornisPermissionType = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
};
AdornisPermissionType._class = "AdornisPermission";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], AdornisPermissionType.prototype, "name", 2);
__decorateClass([
  Field((type) => Boolean, { default: (v) => v ?? false })
], AdornisPermissionType.prototype, "hasValidationHook", 2);
AdornisPermissionType = __decorateClass([
  Entity()
], AdornisPermissionType);
export {
  AdornisPermissionType,
  AdornisRoleToContextsWrapper,
  NativePermissions
};
